import { render, staticRenderFns } from "./RadioButtons.vue?vue&type=template&id=6dccaea3&scoped=true&"
import script from "./RadioButtons.vue?vue&type=script&lang=js&"
export * from "./RadioButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dccaea3",
  null
  
)

export default component.exports